import axiosInstance from "./axiosInstance";

export const ResultAPI = {
  evaluate: async (params) => {
    const result = await axiosInstance.post("/client/results/1", params);

    return result.data;
  },
};
